import React from 'react'

import Markdown from '../../atoms/Markdown'
import Container from '../../atoms/Container'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'

import Blank from '../Blank'

export default ({ source, ...props }) => (
  <Blank {...props}>
    <Container>
      <Row>
        <Col>
          <Markdown children={source} />
        </Col>
      </Row>
    </Container>
  </Blank>
)
